import React from 'react';

export const Diamonds = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M8.00001 0L2.2536 8L8.00001 16L13.7464 8L8.00001 0Z" fill="#924103" />
		</svg>
	);
};
